/**
 * @property {boolean} ga
 */
export default class CookiesConsentRepository {
    constructor() {
        this.ga = true;
    }

    get google() {
        return (this.ga);
    }

    toJSON() {
        return {
            ga: this.ga
        };
    }
}
